import { HttpInterceptorFn } from '@angular/common/http';
import { isBffMode, isLegacyAuthDisabled } from './bff';
import { activeClientSession, isClientPreview } from './client-session';

export function readAccessToken(): string | null {
  const raw = localStorage.getItem('authState');
  if (!raw) return null;
  try {
    return (JSON.parse(raw) as { accessToken?: string }).accessToken ?? null;
  } catch {
    return null;
  }
}

/** Токен для hello MCP-моста: BFF-сессия идёт кукой, протухший до-миграционный токен хабу не предъявляем. */
export function editorMcpAccessToken(): string {
  return isBffMode() ? '' : (readAccessToken() ?? '');
}

// Под LEGACY_AUTH_DISABLED (стендовый hard cutover) уже открытая legacy-вкладка
// фотографа/координатора больше не подмешивает старый bearer из localStorage — этот флаг по
// умолчанию false, поведение не меняется, пока координатор явно не включит его на стенде.
// activeClientSession() — постоянное исключение (PIN-клиент protected-проекта архитектурно всегда
// на прямом токене, см. client.store.ts confirmLogin), не часть этой миграции и не гасится флагом.
function legacyBearerAllowed(): boolean {
  // Просмотр «как клиент» под исключение не подпадает: вкладка ходит кукой фотографа, а
  // activeClientSession() отдаёт ей запись просмотра — легаси-токен здесь ничей.
  return !isLegacyAuthDisabled() || !isBffMode() || (!!activeClientSession() && !isClientPreview());
}

// Охват УЖЕ не тот, что у корреляции (`isOwnBackendUrl`, там ещё и `/bridge`): на мост ходят кукой, и
// легаси-bearer ему предъявлять нечем — не сводить эти два правила в одно.
export const bearerInterceptor: HttpInterceptorFn = (req, next) => {
  const token = req.url.startsWith('/api') && legacyBearerAllowed() ? readAccessToken() : null;
  return token ? next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })) : next(req);
};
